/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{useState,useEffect} from "react";
import { GetCookies } from "../../_helpers/Cookies";
import { FaRegUser } from 'react-icons/fa';
import { toAbsoluteUrl } from "../../_helpers";
// import {ApiDataNatural} from "./ApiDataTable/ApiDataNatural"
// import {ApiDataLab} from "./ApiDataTable/ApiDataLab"
import { ApiDataTable } from "./ApiDataTable/APIDataTable";
import { useHistory } from "react-router-dom";
  import PropTypes from "prop-types";
  import SelectFieldCurrency from "./ApiSetup/FormFields/SelectFieldCurrency";
  import { NODE_API_URL,BASE_URL } from "../../../env_config";
  import Cookies from "js-cookie";
  import axios from "axios";
  import { 
    TextField,
    Switch,
    FormControlLabel,
    Tabs,
    Tab,
    Typography,
    withStyles
  } from '@material-ui/core';
  import { TaxPopUp } from "../Popup/TaxPopUp";
  import {
    FaRegEdit,
} from "react-icons/fa";
import { SwalWarn } from "../Popup";
import teal from "material-ui/colors/teal";
import { IoSettingsOutline } from "react-icons/io5";

import {ShortListDetail} from "./ShortList/ShortListDetail/ShortListDetail"
import { ShortListTable } from "./ShortList/ShortListTable";
import { ShortListTableByMail } from "./ShortList/shortListByMail/ShortListTableByMail";
import { OrderHistoryDetail } from "./OrderHistory/OrderHistoryDetail";
  function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
  }
  
  TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
  };
  const CustomSwitch = withStyles({
    switchBase: {
      color: teal[300],
      '&$checked': {
        color: teal[500],
      },
      '&$checked + $track': {
        backgroundColor: teal[500],
      },
    },
    checked: {},
    track: {},
  })(Switch);
export const RulePage = (props) => {
  const [tab, setTab] = useState(0);
  
      const handleRulePageTabChange = (event, newValue) => {
          setTab(newValue);
      };

    const history = useHistory()
    const [currencyvalue,setCurrencyValue] = useState("")
    const [supplieron,setSupplierOn] = useState(null)
    const [shortlistSwitch ,setShortlistSwitch] = useState(true)
    const [shortlistSwitchByMail ,setShortlistSwitchByMail] = useState(false)
    const [shortlistDataByMail ,setShortlistDataByMail] = useState([])
    const [value, setValue] = useState(0);
    useEffect(() => {
        setCurrencyValue(props.customeriframeorapi.api_currency)
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/fetch-supplier-step`,
            headers: {
              "Content-Type": "application/json",
               "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
          },
            data: {
                "api_id":props.customeriframeorapi.api_id
            },
        }).then(supreq => {
            if(supreq && supreq.data){
                if(supreq.data !== "Please Turn On Suppliers"){
                    setSupplierOn(supreq.data)

                }
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
    },[props.customerapi,props.customeriframeorapi])
      function handleTabChange(event, newValue) {
        setValue(newValue);
    }
    return (
        <>
            {props.customeriframeorapi.api_plan !== "API_V2"?<div className="card shadow-none card-custom">
                <div className="card-header">
                  <h3 className="card-title">{props.customeriframeorapi.feed_type === "API"?"API Dashboard": (props.customeriframeorapi.feed_type === "SHOPIFY APP" || props.customeriframeorapi.feed_type === "SHOPIFY APP RING") ? "Shopify App Dashboard" :"IFrame Dashboard"}</h3>
                  <div className=" card-toolbar d-flex align-items-center">                            
                      {props.customeriframeorapi.feed_type === "IFrame Plug-in" ?
                        <button className="btn btn-text-dark btn-hover-light-dark" 
                          onClick={() => history.push({
                            pathname: "/iframe-setting",
                            state: "embeddedcode"
                            // state: decompress(res.data.ProductDetails),
                          })}><IoSettingsOutline className="mr-2" />{props.language.DIAMOND_FEED_NATURAL_COLORMARKUP_IFRAMESETTING}</button> :""}
                      {props.customeriframeorapi.feed_type === "API" ? 
                        <button className="btn btn-text-dark btn-hover-light-dark" 
                          onClick={() => history.push({
                            pathname: "/api-setting"
                            // state: decompress(res.data.ProductDetails),
                        })}><IoSettingsOutline className="mr-2" />{props.language.DIAMOND_FEED_NATURAL_COLORMARKUP_APISETTING}</button>:""}
                      {(props.customeriframeorapi.feed_type === "SHOPIFY APP" || props.customeriframeorapi.feed_type === "SHOPIFY APP RING") ? 
                        <button className="btn btn-text-dark btn-hover-light-dark" 
                          onClick={() => history.push({
                            pathname: "/shopify-app-setting"
                        })}><IoSettingsOutline className="mr-2" />{props.language.DIAMOND_FEED_SHOPIFY_APP_SETTING}</button>:""}
                  </div>
              </div>
              {props.customeriframeorapi.feed_type === "API" ? <div className={`col-12 px-0 border-bottom`}>
                <Tabs
                    variant="scrollable"
                    value={tab}
                    onChange={handleRulePageTabChange}
                >
                    <Tab label="Mark-up rules Manager" />
                    <Tab label="Order History" />
                </Tabs>
              </div> : ""}
              {props.customeriframeorapi.feed_type === "API"?<div className="py-3 bg-white">  
                {tab === 0 ? <ApiDataTable userinfo={props.userinfo} language={props.language} customerapi={props.customerapi} setUpdateData={props.setUpdateData} updatedata={props.updatedata} currencyvalue={currencyvalue} supplieron={supplieron} loader={props.loader} setCustomerAPI={props.setCustomerAPI} customeriframeorapi={props.customeriframeorapi}/> : ""}
                {tab === 1 ? <div className="">
                            <OrderHistoryDetail userinfo={props.userinfo} language={props.language}/>
                            </div> : ""}
              </div>: (props.customeriframeorapi.feed_type === "SHOPIFY APP" || props.customeriframeorapi.feed_type === "SHOPIFY APP RING") ? <ApiDataTable userinfo={props.userinfo} language={props.language} customerapi={props.customerapi} setUpdateData={props.setUpdateData} updatedata={props.updatedata} currencyvalue={currencyvalue} supplieron={supplieron} loader={props.loader} setCustomerAPI={props.setCustomerAPI} customeriframeorapi={props.customeriframeorapi}/> :
              <>
              <div className="col-12 d-md-flex bg-white align-items-center justify-content-between"> 
                        <Tabs value={value} onChange={handleTabChange}>
                            <Tab label="Mark-up rules Manager" />
                            <Tab label="Customer Inquiry List" />
                            <Tab label="Order History" />
                        </Tabs>
                    <div className="d-flex align-items-center m-1"> 
                        {
                            value === 1 ?
                            <div className="d-flex align-items-center m-1 border rounded px-5">
                                    <span className="font-weight-bold text-muted small">Stone Wise</span>
                                    <CustomSwitch
                                        checked={shortlistSwitch}
                                        onClick={() => setShortlistSwitch(!shortlistSwitch)}
                                    />
                                    <span className="font-weight-bold text-muted small">User Wise</span>
                                </div>
                            : null
                        }
                    </div>
                </div>
                    {value === 0 && (
                                        <ApiDataTable userinfo={props.userinfo} language={props.language} customerapi={props.customerapi} setUpdateData={props.setUpdateData} updatedata={props.updatedata} currencyvalue={currencyvalue} supplieron={supplieron} loader={props.loader} setCustomerAPI={props.setCustomerAPI} customeriframeorapi={props.customeriframeorapi}/>

                    )}
                        {value === 1 && (
                            <div className="col-12 bg-white">
                                <TabContainer className="p-0">
                                    {!shortlistSwitch ? 
                                        <ShortListDetail userinfo={props.userinfo} language={props.language} conversionrate={props.conversionrate} symbol={props.symbol}/>
                                        : !shortlistSwitchByMail ?
                                            <ShortListTable userinfo={props.userinfo} language={props.language} conversionrate={props.conversionrate} symbol={props.symbol} setShortlistSwitchByMail={setShortlistSwitchByMail} setShortlistDataByMail={setShortlistDataByMail} /> 
                                            : <ShortListTableByMail userinfo={props.userinfo} language={props.language} conversionrate={props.conversionrate} symbol={props.symbol} shortlistDataByMail={shortlistDataByMail} setShortlistSwitchByMail={setShortlistSwitchByMail}/>
                                    }
                                </TabContainer>
                            </div>
                        )}
                        {value === 2 ? <div className="col-12 pt-3">
            <OrderHistoryDetail userinfo={props.userinfo} language={props.language}/>
            </div> : ""}
                    </>
              }
            </div>:
            <div className="card shadow-none card-custom">
                <div className="card-header">
                  <h3 className="card-title">Diamond Feed Center</h3>
                  <div className=" card-toolbar d-flex align-items-center">
                      {props.customeriframeorapi.feed_type === "IFrame Plug-in" ?
                        <button className="btn font-weight-bold btn-square btn-secondary px-10" 
                          onClick={() => history.push({
                            pathname: "/iframe-setting",
                            state: "embeddedcode"
                            // state: decompress(res.data.ProductDetails),
                          })}><IoSettingsOutline className="mr-2" />{props.language.DIAMOND_FEED_NATURAL_COLORMARKUP_IFRAMESETTING}</button> :""}
                      {props.customeriframeorapi.feed_type === "API" ? 
                        <button className="btn font-weight-bold btn-square btn-secondary px-8 mr-2" 
                          onClick={() => history.push({
                            pathname: "/api-setting"
                            // state: decompress(res.data.ProductDetails),
                        })}><IoSettingsOutline className="mr-2" />{props.language.DIAMOND_FEED_NATURAL_COLORMARKUP_APISETTING}</button>:""}
                  </div>
              </div>
              <div className="card-body text-right">
                <img className="img-gluid" src={toAbsoluteUrl("/media/General/diamond_feed_approved.svg")} alt="diamond feed" style={{maxWidth:"800px"}}/>
                {/* <SVG  /> */}
              </div>
              {/* <div className="api-home-svg api-success"><SVG src={toAbsoluteUrl("/media/General/diamond_feed_request.svg")} /></div> */}
            </div>}
        </>
    );
};
